<!--
 * @Author: LUMING.LIU
 * @Date: 2020-09-08 10:27:32
 * @LastEditTime: 2020-09-14 17:12:32
 * @Description: write you description
-->
<template>
  <div class="product-code-filter" ref="product-code-filter">
    <i-checkbox
      class="title"
      :disabled="selectDisabled"
      :indeterminate="indeterminate"
      :value="checkAll" @click.prevent.native="selectAllOrCanelAll">型号简称</i-checkbox>
    <i-select
      v-model="productCodesFilter"
      filterable
      multiple
      size="small"
      :placeholder="selectDisabled ? '无匹配数据' : '请选择'"
      :disabled="selectDisabled"
      @on-change="selectOptionsChanged"
      @on-query-change="selectQueryChanged">
      <i-option
        v-for="(product) in showProductList"
        :value="product.productCode"
        :key="product.productCode">{{ product.shortName }}</i-option>
    </i-select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ProductCodeFilter',
  props: {
    productList: { type: Array, required: true },
  },
  data() {
    return {
      indeterminate: false,
      checkAll: false,
      showProductList: [],
      productCodesFilter: [],
    };
  },
  computed: {
    ...mapGetters({
      filters: 'libraryStore/filters',
    }),
    groupsFilter() {
      return this.filters.productGroupCodes;
    },
    productCodesFilterStore() {
      return this.filters.productCodes;
    },
    selectDisabled() {
      return this.productList.length === 0;
    },
  },
  watch: {
    productList: {
      immediate: true,
      handler(productList) {
        const list = JSON.parse(JSON.stringify(productList));
        this.showProductList = list;
      },
    },
    productCodesFilter(productCodes) {
      this.setProductCodesFilter({ productCodes });
    },
    productCodesFilterStore(productCodes) {
      this.productCodesFilter = productCodes;

      if (productCodes.length === 0) {
        this.checkAll = false;
        this.indeterminate = false;
      }
    },
    groupsFilter() {
      this.productCodesFilter = [];
      this.checkAll = false;
      this.indeterminate = false;
    },
  },
  methods: {
    ...mapActions({
      setProductCodesFilter: 'libraryStore/invokeSetProductCodesFilter',
    }),
    selectAllOrCanelAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;

      this.productCodesFilter = [];
      if (this.checkAll) {
        this.productList.forEach((product, index) => {
          this.$set(this.productCodesFilter, index, product.productCode);
        });
      }
    },
    selectOptionsChanged(productCodes) {
      if (productCodes.length === this.productList.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (productCodes.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
    },
    selectQueryChanged(value) {
      const productList = JSON.parse(JSON.stringify(this.productList));

      if (value.trim().length === 0) {
        this.showProductList = productList;
        return;
      }

      const list = [];
      productList.forEach((product) => {
        if (product.shortName.includes(value)) {
          list.push(product);
        }
      });

      this.showProductList = list;
    },
  },
};
</script>

<style lang="less" scoped>
.product-code-filter {
  position: relative;
  margin-bottom: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  max-width: 680px;

  > .title {
    margin-right: 12px;
    font-size: 13px;
    white-space: nowrap;

    /deep/ .ivu-checkbox {
      margin-right: 6px;
    }
  }

  /deep/ .ivu-select-dropdown {
    padding: 0;

    .ivu-select-dropdown-list {
      padding: 4px 8px;

      .ivu-select-item {
        margin: 0;
        padding: 3px 0;
        font-size: 13px !important;

        &:hover {
          background-color: #f3f3f3;
        }
      }

      .ivu-select-item-focus {
        background-color: transparent;
      }

      .ivu-select-item-selected::after {
        font-size: 16px;
      }
    }
  }
}
</style>
